import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { CHANNELS } from '../../../constants/channels';
import { CymbioSpinner } from '../../common/Spinner';
import { getRetailer } from '../../../store/actions/retailer';
import { TikTokWarehouseSelect } from '../../integrations/tiktok/TikTokWarehouseSelect';
import { TikTokBrandIdMapper } from './TikTokBrandIdMapper';

import styles from './TikTokConfigurationPage.module.scss';

const DisplayedPage = {
  LOADING: 'loading',
  SELECT_WAREHOUSE: 'select_warehouse',
  MAP_BRAND_ID: 'map_brand_id',
};

export function TikTokConfigurationPage() {
  const dispatch = useDispatch();
  const { supplierId, retailerId } = useParams();

  const { missing_retailer_configurations: requiredConfigurations } = useSelector((state) => state.retailer.current);
  const tikTokRequiredConfigurations = useSelector((state) => state.channels.requiredConfigurations[CHANNELS.TIKTOK]);

  const displayedPage = useMemo(() => {
    const needsToConfigureWarehouseId =
      requiredConfigurations.products?.includes('warehouseId') && !tikTokRequiredConfigurations?.hasWarehouseId;
    const needsToConfigureBrandIdMapping =
      requiredConfigurations.products?.includes('brandIdMapping') && !tikTokRequiredConfigurations?.hasBrandIdMapping;

    if (!needsToConfigureWarehouseId && !needsToConfigureBrandIdMapping) {
      return;
    }

    if (!retailerId) {
      return DisplayedPage.LOADING;
    }

    if (needsToConfigureWarehouseId) {
      return DisplayedPage.SELECT_WAREHOUSE;
    }

    if (needsToConfigureBrandIdMapping) {
      return DisplayedPage.MAP_BRAND_ID;
    }
  }, [retailerId, requiredConfigurations, tikTokRequiredConfigurations]);

  useEffect(() => {
    if (!retailerId || !displayedPage) {
      dispatch(getRetailer(retailerId, false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerId, displayedPage]);

  return (
    <div className={styles.wrapper}>
      {displayedPage === DisplayedPage.LOADING && <CymbioSpinner shouldCenterVerticallyInViewport />}
      {displayedPage === DisplayedPage.SELECT_WAREHOUSE && (
        <TikTokWarehouseSelect supplierId={Number(supplierId)} retailerId={Number(retailerId)} />
      )}
      {displayedPage === DisplayedPage.MAP_BRAND_ID && (
        <TikTokBrandIdMapper
          supplierId={Number(supplierId)}
          retailerId={Number(retailerId)}
          onSkip={() => dispatch(getRetailer(retailerId, false))}
        />
      )}
    </div>
  );
}
